import { useLocation } from 'react-router-dom';
import config from '@plone/volto/registry';
import { Grid } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import cx from 'classnames';

import { getColumns } from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { getStyle } from '@eeacms/volto-columns-block/Styles';

// import styles from './ColumnsBlock.module.less';

if (typeof window !== 'undefined') {
  function _calculateScrollbarWidth() {
    document.body.style.setProperty(
      '--scrollbar-width',
      window.innerWidth - document.documentElement.clientWidth + 'px',
    );
    document.body.style.setProperty(
      '--document-width',
      document.documentElement.clientWidth + 'px',
    );
  }

  // recalculate on resize
  window.addEventListener('resize', _calculateScrollbarWidth, false);
  // recalculate on dom load
  document.addEventListener(
    'DOMContentLoaded',
    _calculateScrollbarWidth,
    false,
  );
  // recalculate on load (assets loaded as well)
  window.addEventListener('load', _calculateScrollbarWidth);
}

const ColumnsBlockView = (props) => {
  const location = useLocation();
  const { gridSizes } = config.blocks.blocksConfig[COLUMNSBLOCK];
  const {
    data = {},
    gridSize = 12,
    gridCols = [],
    fullWidth = 'none',
    backgroundColor,
    increasePadding,
  } = props.data;
  const metadata = props.metadata || props.properties;
  const columnList = getColumns(data);
  const customId = props.data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  const blockClasses = cx('column-wrapper', 'columns-view', backgroundColor, {
    'custom-color': backgroundColor !== 'transparent',
    none: fullWidth === 'none',
    full: fullWidth === 'background',
    cont: fullWidth === 'all',
    pad: increasePadding,
  });

  const gridClasses = cx('column-grid', {
    'reverse-wrap': props.data.reverseWrap,
  });

  // Verifica se todas as colunas têm o mesmo tamanho
  const equalColumns = gridCols.every((col) => col === gridCols[0]);

  return (
    <div id={customId} className={blockClasses}>
      <div className={cx('wrap', { 'ui containter': fullWidth === 'all' })}>
        <Grid
          columns={equalColumns ? gridCols.length : gridSize}
          className={gridClasses}
          stackable
        >
          {columnList.map(([id, column], index) => {
            return (
              <Grid.Column
                key={id}
                {...(!equalColumns &&
                  (gridSizes[gridCols[index]] || gridCols[index]))}
                className={cx(
                  'column-blocks-wrapper',
                  column.settings?.column_class,
                  'col',
                )}
                {...getStyle(column.settings || {})}
              >
                <RenderBlocks
                  {...props}
                  location={location}
                  metadata={metadata}
                  content={column}
                />
              </Grid.Column>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default ColumnsBlockView;
